import { render, staticRenderFns } from "./ChartRenderer.vue?vue&type=template&id=6879d2ac&scoped=true"
import script from "./ChartRenderer.vue?vue&type=script&lang=js"
export * from "./ChartRenderer.vue?vue&type=script&lang=js"
import style0 from "./ChartRenderer.vue?vue&type=style&index=0&id=6879d2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879d2ac",
  null
  
)

export default component.exports